'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var runtime = _sdk2.default.runtime;
var ref = _sdk2.default.utils;
var configUtils = ref.configUtils;
var constants = ref.constants;
var ref$1 = _sdk2.default.shapes;
var Text = ref$1.Text;
var Layer = ref$1.Layer;
var ref$2 = _sdk2.default.scene.model;
var Cell = ref$2.Cell;

function _plotTitle(config, cell, theme) {
  var titleLayer = new Layer({
    cell: cell,
    key: "chart-title"
  });
  var padding = constants.PADDING;
  var align = config.align;
  var x = 0;
  var y = 0;

  switch (align) {
    case "right":
      x = cell.get("w");
      break;

    case "center":
      x = cell.get("w") / 2;
      break;

    default:
      break;
  }

  if (config.label) {
    new Text({
      valign: "top",
      halign: align,
      maxWidth: cell.get("w"),
      padding: {
        top: padding
      },
      layer: titleLayer,
      accessibility: {
        type: constants.ACCESSIBILITY.TYPE.CAPTION,
        key: constants.ACCESSIBILITY.CAPTION_KEY.TITLE,
        value: config.label
      },
      key: "chart-title-text",
      text: config.label,
      x: x,
      y: y,
      stroke: theme.getChartTitleColor(),
      size: config.fontSize
    });
    y += runtime.getDelegate().getRealFontSize(config.fontSize) + constants.TITLE.PADDING_BETWEEN_SUBTITLE;
  }

  if (config.subtitleLabel) {
    new Text({
      valign: "top",
      halign: align,
      maxWidth: cell.get("w"),
      padding: {
        top: config.label ? 0 : padding
      },
      layer: titleLayer,
      key: "chart-subtitle-text",
      x: x,
      y: y,
      text: config.subtitleLabel,
      stroke: theme.getChartSubtitleColor(),
      size: config.subtitleFontSize,
      accessibility: {
        type: constants.ACCESSIBILITY.TYPE.CAPTION,
        key: constants.ACCESSIBILITY.CAPTION_KEY.SUBTITLE,
        value: config.subtitleLabel
      }
    });
  }
}

exports.default = {
  /**
   * functions for title plot
   */
  getTitleSize: function getTitleSize(config) {
    var res = 0;

    if (config.label) {
      res += runtime.getDelegate().getRealFontSize(config.fontSize) + (config.subtitleLabel ? constants.TITLE.PADDING_BETWEEN_SUBTITLE : constants.TITLE.PADDING_BOTTOM);
    }

    if (config.subtitleLabel) {
      res += runtime.getDelegate().getRealFontSize(config.subtitleFontSize) + constants.TITLE.PADDING_BOTTOM;
    }

    return res;
  },
  // Adjust the chart padding to accommodate for the title in the scene
  adjustChartPaddingForTitle: function adjustChartPaddingForTitle(chartPadding, titleSize) {
    if (titleSize > 0) {
      chartPadding.top += titleSize;
    }

    return chartPadding;
  },
  getTitleCell: function getTitleCell(config, titleSize, title, theme, sceneSize, scenePadding) {
    var transforms = configUtils.isTrellis(config) ? null : config.transforms;
    var padding = config.padding;
    var vertical = transforms ? config.transforms.rotate : false;
    var titleCell = new Cell({
      key: "chartTitle",
      skipTransforms: true,
      w: vertical ? sceneSize[1] - scenePadding.right - scenePadding.left : sceneSize[0] - scenePadding.right - scenePadding.left,
      h: titleSize,
      x: padding.left ? -padding.left + scenePadding.left : 0,
      y: padding.top ? -padding.top + scenePadding.top : -titleSize
    });

    _plotTitle(title, titleCell, theme);

    return titleCell;
  }
};

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;